import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaMutationApi } from 'api/kinerja/utils/api'

import type { UseMutationOptions } from 'react-query'
import type { ParamsPelaksanaanAppealApproval } from 'types/kinerja-ks-pelaksanaan'

export function useApiPostResetPelaksanaanAction(
  { period }: { period?: { year?: number; no?: number } },
  opts?: UseMutationOptions<unknown, Error, ParamsPelaksanaanAppealApproval>
) {
  const skpYear = period?.year
  const skpPeriod = period?.no

  return useKinerjaMutationApi(
    `${apiPaths.pelaksanaanPengawasSekolah}/process-reset`,
    {
      axiosConfig: {
        method: 'POST',
        params: {
          ...(!!skpYear && !!skpPeriod
            ? { skp_year: skpYear, skp_period: skpPeriod }
            : {}),
        },
      },
      mutationConfig: {
        ...opts,
      },
    }
  )
}
